import ShowDetails from "./components/kyc-admin/show.vue";
import LandingPage from "./components/kyc-admin/index.vue";
import LandingPageCKyc from "./components/ckyc-admin/index.vue";
import ShowDetailsCkyc from "./components/ckyc-admin/show.vue"
import Login from "./components/Login.vue";
import Template from "./components/template.vue";
import KycData from "./components/Kyc-data.vue";
import RotateImage from "./commons/RotateImage/RotateImage.vue";
import MaskImage from "./commons/MaskImage/MaskImage.vue"
import RotateImageCkyc from "./commons/RotateImage/RotateImageCkyc.vue";
import MaskImageCkyc from "./commons/MaskImage/MaskImageCkyc.vue"
const routes = [
  {
    path: "/",
    component: Template,
    meta: {
      title: "KYC Verification"
    },
    children: [
      { path: "", name: "kyc-login", component: Login },
      {
        path: "/dashboard",
        name: "dashboard",
        component: KycData,
        meta: { auth: true },
        children: [
          {
            path: "/mask/:id/:imgname",
            name: "kyc-details-mask-img",
            component: MaskImage
          },
          {
            path: "/kyc-details-id/:id/:imgname",
            name: "kyc-details-edit-img",
            component: RotateImage
          },
          {
            path: "/kyc-details-id/:id",
            name: "kyc-details-id",
            component: ShowDetails
          },
          {
            path: "/kyc-details/:status",
            name: "kyc-details",
            component: LandingPage,
          },
          {
            path: "/ckyc-details/:status",
            name: "ckyc-details",
            component: LandingPageCKyc
          },
          {
            path: "/ckyc-details-id/:id",
            name: "ckyc-details-id",
            component: ShowDetailsCkyc
          }, 
          {
            path: "/ckyc-mask/:id/:imgname",
            name: "ckyc-details-mask-img",
            component: MaskImageCkyc
          },
          {
            path: "/ckyc-details-id/:id/:imgname",
            name: "ckyc-details-edit-img",
            component: RotateImageCkyc
          },                  
        ]
      }
    ]
  },
  { path: "*", redirect: "/" }
];

export default routes;
